import * as React from "react";
import { Modal } from 'antd';
import { useState } from 'react';
import { IExpenseDetail } from 'src/services/interfaces/Expense/IExpenseDetail';
import { DataGrid } from 'devextreme-react';
import { Column } from 'devextreme-react/data-grid';
import { MoneyMask } from 'src/util/Masks/MoneyMask';
import { ExpenseStatusLabel, ExpenseStatusEnum } from 'src/services/Enum/ExpenseStatusEnum';

interface IModalCreatedExpenseProps {
    expenses: IExpenseDetail[]
}

export const ModalCreatedExpense: React.FC<IModalCreatedExpenseProps> = ({ expenses }) => {
    const [showModal, setShowModal] = useState(!!expenses)

    const hasMultipleExpenses = expenses?.length > 1

    return (
        <Modal
            className="modal-created-expense"
            title="Despesas criadas"
            visible={showModal}
            maskClosable={false}
            onCancel={() => setShowModal(false)}
            onOk={() => setShowModal(false)}
        >
            <p>
                Para fins de controle interno sua nota fiscal {expenses?.[0].invoice.number} com valor total {MoneyMask(expenses?.[0].invoice.totalValue)} foi processada {hasMultipleExpenses ? "nos IDs" : "no ID"} abaixo.
                {hasMultipleExpenses ? "O pagamento dos IDs podem ser realizados separadamente" : null}.
            </p>
            <DataGrid dataSource={expenses} showBorders columnAutoWidth>
                <Column caption="ID" dataField="id" alignment="left" dataType="number" />
                <Column
                    caption="Valor"
                    dataField="totalValue"
                    cellRender={params => MoneyMask(params.data.items?.reduce((sum, { value }) => sum + value, 0))} />
                <Column
                    caption="Status"
                    dataField="status"
                    cellRender={params => ExpenseStatusLabel.get(ExpenseStatusEnum[params.data.status])} />
            </DataGrid>
        </Modal>
    );
}


// WEBPACK FOOTER //
// ./src/pages/expenses/DemandedExpenses/ModalCreatedExpense.tsx